<template>
  <div>
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="text-center">
      <img width="250" src="@/assets/img/no_record.png" alt="" />
      <br>
      <span>{{checkingStatus}}</span>      
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      ArrangeGuid: null,
      checkingStatus: "報到中...",
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    checkIn() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.checkInArrange(vm.ArrangeGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.checkingStatus = response.data.ErrorMessage;
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.checkingStatus = response.data.Data;
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.ArrangeGuid = this.$route.query.ArrangeGuid;
    this.checkIn();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.validate-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .el-select,
  .el-input {
    margin-bottom: 20px;
  }
}
.feedback-form {
  max-width: 960px;
  margin: 20px auto;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  table {
    width: 100%;
  }
  .form-title {
    text-align: center;
    font-weight: bold;
    margin: 10px 0;
  }
  th {
    background-color: #f5f5f5;
    font-weight: normal;
    white-space: nowrap;
  }
  td,
  th {
    border: 1px solid #ccc;
    padding: 5px;
    font-size: 0.9em;
  }
  .el-select {
    width: 100%;
  }
  .el-checkbox {
    transform: scale(1.5);
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .el-form-item__error {
    background-color: #f56c6c;
    color: #fff;
    padding: 3px 10px;
    border-radius: 25px;
    float: right;
  }
}

.complete-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .text {
    margin-bottom: 40px;
  }
}
</style>
